"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgba = exports.rgb = void 0;
var rgb = function (r, g, b) { return [r, g, b]; };
exports.rgb = rgb;
var rgba = function (r, g, b, a) {
    return [r, g, b, a];
};
exports.rgba = rgba;
